export default {
    "title": "Landing Page",
    "entityName": "landingpage",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [{
            full: true,
            "value": "title",
            "text": "Titolo",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        {
            full: true,
            "value": "url",
            "text": "Url",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        // {
        //     full: true,
        //     "value": "status",
        //     "text": "Status",
        //     "type": "text",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },
        //     "validators": [
        //         "required"
        //     ],
        // },




    ],
    "actions": [
        {
            "value": "link",
            "text": "Open landing page",
            "icon": "mdi-link",
            "color": "primary",
        },
        {
            "value": "update",
            "text": "Edit",
            "icon": "mdi-pencil",
            "color": "primary",
        },
        'delete'
    ]
}